/* global window */

import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { reduxForm, Field, Form } from 'redux-form';

import AddressFormBlock from 'common/components/address/components/AddressFormBlock';
import { transformAddressData } from 'common/components/address/helpers';
import { TextField, SelectField } from 'common/components/forms';
import BirthDateFormFields from 'common/components/forms/BirthDateFormFields';
// eslint-disable-next-line import/no-cycle
import { FormError, FormErrorNoRouter } from 'common/components/layout';
import { getDefaultCountryCode, getMessage } from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { phoneNormalize } from 'common/helpers/phoneHelper';
import { addCustomerWithAddress } from 'redux/customer/actions';
import {
  asyncValidateEmailNotArray,
  asyncValidatePassword,
  asyncValidateEmailAndPassword
} from 'redux/customer/helpers';

import { validateAdd } from './validators';

class CreateAccountForm extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const { forwardTo, redirectTo } = props;
    const data = transformData(form);
    data.phones = [{ phone: data.phone }];
    data.emails = [{ email: data.email }];
    delete data.confirmPassword;
    delete data.phone;
    delete data.email;
    const successFunction = () => {
      if (forwardTo) {
        window.location.href = forwardTo;
      }
      if (redirectTo) {
        window.location.href = redirectTo;
      }
    };
    props.addCustomerWithAddress(data, successFunction);
  };

  render() {
    const { handleSubmit, form, settings, change, forwardTo } = this.props;
    const object = { countryCode: getDefaultCountryCode(settings) };
    return (
      <div className="c7-account__create-account">
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
          name="Create Account"
          id="c7-create-account"
        >
          {forwardTo && <FormError formName={form} />}
          {!forwardTo && <FormErrorNoRouter formName={form} />}
          <BirthDateFormFields
            name="birthDate"
            countryCode={getDefaultCountryCode(settings)}
          />
          <div className="c7-form__group">
            <Field
              name="firstName"
              label="First Name"
              autocomplete="given-name"
              component={TextField}
              required
            />
            <Field
              name="lastName"
              label="Last Name"
              component={TextField}
              autocomplete="family-name"
              required
            />
          </div>
          <AddressFormBlock
            countryCode={object.countryCode}
            change={change}
            settings={settings}
          />
          <Field
            name="email"
            component={TextField}
            label="Email"
            type="email"
            autocomplete="email"
            required
          />
          <Field
            name="emailMarketingStatus"
            component={SelectField}
            optionArray={emailMarketingStatusOptionArray()}
            label="Subscribe To Email Marketing?"
          />
          <div
            dangerouslySetInnerHTML={{
              __html: getMessage('Email Marketing Message', settings)
            }}
          />
          <Field
            name="phone"
            component={TextField}
            label="Phone"
            type="tel"
            autocomplete="tel-national"
            normalize={phoneNormalize}
            required
          />
          <Field
            name="password"
            formType="password"
            label="Password"
            component={TextField}
            required
          />
          <Field
            name="confirmPassword"
            formType="password"
            label="Confirm Password"
            component={TextField}
            required
          />
          <div className="c7-form__button-row">
            {forwardTo && (
              <Link to="/profile/login" className="c7-button-alt">
                Cancel
              </Link>
            )}
            <button type="submit" className="c7-button">
              Continue
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

const emailMarketingStatusOptionArray = () => {
  const optionArray = [
    { value: '', option: '' },
    { value: 'Subscribed', option: 'Subscribed' },
    { value: 'Unsubscribed', option: 'Unsubscribed' }
  ];
  return optionArray;
};

const transformData = (values) => {
  const formattedData = transformAddressData(values);
  const data = {
    password: values.password,
    confirmPassword: values.confirmPassword,
    email: values.email,
    emailMarketingStatus:
      values.emailMarketingStatus === '' ? null : values.emailMarketingStatus,
    ...formattedData
  };

  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  data.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  data.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  data.birthYear = values.birthYear && convertStringToInteger(values.birthYear);
  const errors = validateAdd(data, ownProps.settings);
  return errors;
};

const mapStateToProps = (state) => {
  let initialValues;
  if (state.setting.data) {
    initialValues = {
      countryCode: getDefaultCountryCode(state.setting)
    };
  }
  return {
    initialValues,
    settings: state.setting
  };
};

const asyncValidate = (values, dispatch, props, blurredFields) => {
  if (blurredFields === 'email') {
    const { email } = values;
    return asyncValidateEmailNotArray(email).then((errors) => {
      if (errors) {
        throw errors;
      }
    });
  }
  if (blurredFields === 'password') {
    const { password } = values;
    return asyncValidatePassword(password).then((errors) => {
      if (errors) {
        throw errors;
      }
    });
  }
  if (blurredFields === undefined) {
    const { email, password } = values;
    return asyncValidateEmailAndPassword(email, password).then((errors) => {
      if (errors) {
        throw errors;
      }
    });
  }
  return null;
};

CreateAccountForm = reduxForm({
  form: 'email',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate,
  asyncValidate,
  asyncBlurFields: ['email', 'password']
})(CreateAccountForm);

export default connect(mapStateToProps, { addCustomerWithAddress })(
  CreateAccountForm
);
